// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MyProfile__header-fda6de {
  display: flex;
  padding: 24px 0 12px 24px;
}

.MyProfile__avatar-ccfd9e {
  display: flex;
  margin-inline-end: 16px;
  align-items: flex-start;
}

.MyProfile__info-e8b0d7 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-inline-end: 64px;
  box-sizing: border-box;
}

.MyProfile__title-e5a0bd {
  font: var(--font-title-8);
  letter-spacing: var(--font-spacing-title-9);
  color: var(--base-110);
  word-break: break-all;
}

.MyProfile__action-button-f728e7 {
  margin-top: 12px;
  align-self: flex-start;
}

.MyProfile__contact-a8191d {
  padding: 8px 24px;
  fill: var(--base-80);
}

.MyProfile__list-item-dc5e2f {
  min-height: 48px;
  padding: 0 24px;
}

.MyProfile__list-icon-b82b32 {
  fill: var(--base-80);
}

.MyProfile__language-suffix-a8beb5 {
  color: var(--brand-primary-40);
}`, "",{"version":3,"sources":["webpack://./src/main/Profile/MyProfile/MyProfile.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,wBAAA;EACA,sBAAA;AACF;;AAEA;EACE,yBAAA;EACA,2CAAA;EACA,sBAAA;EACA,qBAAA;AACF;;AAEA;EACE,gBAAA;EACA,sBAAA;AACF;;AAEA;EACE,iBAAA;EACA,oBAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,8BAAA;AACF","sourcesContent":[".header {\n  display: flex;\n  padding: 24px 0 12px 24px;\n}\n\n.avatar {\n  display: flex;\n  margin-inline-end: 16px;\n  align-items: flex-start;\n}\n\n.info {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding-inline-end: 64px;\n  box-sizing: border-box;\n}\n\n.title {\n  font: var(--font-title-8);\n  letter-spacing: var(--font-spacing-title-9);\n  color: var(--base-110);\n  word-break: break-all;\n}\n\n.action-button {\n  margin-top: 12px;\n  align-self: flex-start;\n}\n\n.contact {\n  padding: 8px 24px;\n  fill: var(--base-80);\n}\n\n.list-item {\n  min-height: 48px;\n  padding: 0 24px;\n}\n\n.list-icon {\n  fill: var(--base-80);\n}\n\n.language-suffix {\n  color: var(--brand-primary-40);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `MyProfile__header-fda6de`,
	"avatar": `MyProfile__avatar-ccfd9e`,
	"info": `MyProfile__info-e8b0d7`,
	"title": `MyProfile__title-e5a0bd`,
	"action-button": `MyProfile__action-button-f728e7`,
	"actionButton": `MyProfile__action-button-f728e7`,
	"contact": `MyProfile__contact-a8191d`,
	"list-item": `MyProfile__list-item-dc5e2f`,
	"listItem": `MyProfile__list-item-dc5e2f`,
	"list-icon": `MyProfile__list-icon-b82b32`,
	"listIcon": `MyProfile__list-icon-b82b32`,
	"language-suffix": `MyProfile__language-suffix-a8beb5`,
	"languageSuffix": `MyProfile__language-suffix-a8beb5`
};
module.exports = ___CSS_LOADER_EXPORT___;
